<template>
	<cus-header>
		<div class="flex-center container">
			<!-- <img src="../../assets/home/container-bg.png" class="container-bg" alt="" /> -->
			<div class="con-group" v-if="!isDrilling">
				<!-- <div class="con-item" @click="jump('http://122.51.76.10:8084')">
					<img src="../../assets/home/icon07.png"></img>
					<div>
						<div class="title">一流课程</div>
						<div class="text">黑龙江省一流本科课程管理系统</div>
					</div>
				</div>
				<div class="con-item" @click="jump('http://122.51.76.10:8083')">
					<img src="../../assets/home/icon01.png"></img>
					<div>
						<div class="title">规划教材</div>
						<div class="text">黑龙江省“十四五”普通高等教育本科规划教材管理系统</div>
					</div>
				</div> -->
				<div class="con-item" @click="jump('http://122.51.76.10:8082')">
					<img src="../../assets/home/icon02.png"></img>
					<div>
						<div class="title">项目管理</div>
						<div class="text">实验教学和教学实验室建设项目<br>本科毕业论文改革项目</div>
					</div>
				</div><!-- jump('http://222.27.186.55/sjsfzx/') -->
				<div class="con-item" @click="jump('http://122.51.76.10:8088')">
					<img src="../../assets/home/icon03.png"></img>
					<div>
						<div class="title">示范中心</div>
						<div class="text">示范中心申报、示范中心年报、示范中心阶段性总结、示范中心数据分析</div>
					</div>
				</div>
				<div class="con-item" @click="drilling()">
					<img src="../../assets/home/icon09.png"></img>
					<div>
						<div class="title">课程思政</div>
						<div class="text">课程思政示范课程、课程思政教学团队、课程思政优秀教学案例</div>
					</div>
				</div>
				<div class="con-item" @click="itemClick('')">
					<img src="../../assets/home/icon05.png"></img>
					<div>
						<div class="title">实验室管理</div>
						<div class="text">教学实验室安全年报、实验室数据统计分析、实验室智慧管理平台</div>
					</div>
				</div>
				<div class="con-item" @click="itemClick('')">
					<img src="../../assets/home/icon04.png"></img>
					<div>
						<div class="title">资源共享</div>
						<div class="text">实验设备共享、实验课程资源共享、实验项目资源共享、实验教材资源共享</div>
					</div>
				</div>
				<div class="con-item" @click="jump('http://122.51.76.10:8086/')">
					<img src="../../assets/home/icon06.png"></img>
					<div>
						<div class="title">专创融合</div>
						<div class="text">新文科大赛实践创新大赛</div>
					</div>
				</div>
				<div class="con-item" @click="jump('http://122.51.76.10:8093/')">
					<img src="../../assets/home/icon10.png"></img>
					<div>
						<div class="title">101计划</div>
						<div class="text">101计划成果填报、项目遴选</div>
					</div>
				</div>
				<div class="con-item" @click="jump('http://122.51.76.10:8094/')">
					<img src="../../assets/home/icon11.png"></img>
					<div>
						<div class="title">人才培养基地</div>
						<div class="text">基础学科高水平人才培养基地建设</div>
					</div>
				</div>
				<!-- <div class="con-item" style="background: none;padding: 0;" >
					<img style="width: 100%;height: 100%;" src="../../assets/home/expectation.png" alt="" />
				</div> -->
			</div>
			<div class="con-group-dr flex-center" v-else>
				<div class="con-group-con flex">
					<div class="con-group-dr-item" @click="jump('http://122.51.76.10:8091/')">
						<img src="../../assets/home/dorp_icon_1.png" alt="" />
						<div class="pos-con">
							<div class="pos-title">
								课程思政管理系统
							</div>
							<div class="pos-line"></div>
							<div class="pos-text">黑龙江省高等学校课程思政示范课程和教学团队培育项目管理系统</div>
						</div>
					</div>
					<div class="con-group-dr-item" @click="jump('http://122.51.76.10:8092/')">
						<img src="../../assets/home/dorp_icon_2.png" alt="" />
						<div class="pos-con">
							<div class="pos-title">
								优秀案例管理系统
							</div>
							<div class="pos-line"></div>
							<div class="pos-text">黑龙江省高校课程思政优秀教学案例管理系统</div>
						</div>
					</div>
				</div>
			</div>
			<floor class="mobile"></floor>
		</div>
		<div class="home-return col-center" v-if="isDrilling" @click="isDrilling = fals">
			<img src="../../assets/home/icon_back.png" alt="">
			<div>返回平台入口</div>
		</div>
	</cus-header>
</template>

<script>
	import floor from '@/components/floor/floor' //页脚
	export default {
		name: '',
		props: {

		},
		components: {
			floor
		},
		data() {
			return {
				isDrilling: false
			}
		},
		mounted(e) {},
		created() {

		},
		onShow() {

		},
		beforeDestroy() {

		},
		methods: {
			itemClick(text) {
				const h = this.$createElement;
				this.$alert(text || '暂未开通！', '提示', {
					confirmButtonText: '确定',
					message: h('p', null, [
						h('div', {
							style: 'color: #000;font-size:18px;'
						}, text || '暂未开通')
					]),
					callback: action => {

					}
				});
			},
			jump(url) {
				window.open(url)
			},
			drilling() {
				this.isDrilling = true
			}
		},
		options: {
			styleIsolation: 'shared'
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		// width: 1900px;
		width: 67.708vw;
		position: absolute;
		left: 50%;
		// margin-left: -950px;
		margin-left: -33.85416vw;
		padding-top: 0px;
		top: 0;

		.mobile {
			display: none;
		}

		.container-bg {
			position: absolute;
			left: 0;
			right: 0;
			top: -11.979vw;
			width: 67.708vw;
		}

		.con-group {
			display: flex;
			flex-wrap: wrap;
			// padding: 0px 170px;
			justify-content: space-between;

			.con-item {
				width: calc((67.708vw - 4.6875vw) / 4);
				height: calc((60vw - 4.6875vw) / 4);
				background: url(../../assets/home/box.png) no-repeat;
				background-size: 100% 100%;
				margin-bottom: 1.5625vw;
				padding: 1.25vw 1.35416vw 1.25vw 1.35416vw;
				box-sizing: border-box;
				cursor: pointer;
				transition: all .3s;
				text-align: center;
				// display: flex;
				// align-items: center;

				img {
					// flex-shrink: 0;
					// margin: 0 auto;
					width: 5.20833vw;
					height: 5.20833vw;
				}

				.title {
					font-size: 1.354166vw;
					font-weight: bold;
				}

				.text {
					font-size: .83333vw;
					padding-top: .83333vw;
				}
			}

			.con-item:hover {
				transform: scale(1.05);
			}
		}
	}

	// 下砖样式

	.con-group-dr {
		.con-group-con {
			.con-group-dr-item {
				width: 380px;
				height: 480px;
				position: relative;
				margin: 0 30px;
				transition: all .3s;
				cursor: pointer;

				>img {
					width: 100%;
				}

				.pos-con {
					position: absolute;
					z-index: 2;
					left: 0;
					right: 0;
					bottom: 0;
					top: 0;
					padding: 40px 35px;

					.pos-title {
						font-weight: bold;
						font-size: 30px;
						color: #345687;
					}

					.pos-line {
						margin: 30px 0;
						width: 40px;
						height: 5px;
						background: #CEDDF5;
					}

					.pos-text {
						font-family: Source Han Sans CN;
						font-size: 18px;
						color: #48638A;
						line-height: 30px;
					}
				}
			}

			.con-group-dr-item:hover {
				transform: scale(1.05);
			}
		}
	}

	.home-return {
		position: fixed;
		z-index: 9;
		width: 180px;
		height: 48px;
		background: rgba(154, 195, 255, 0.1);
		border-radius: 4px;
		border: 1px solid #9DC7FF;
		font-size: 18px;
		color: #FFFFFF;
		top: 80px;
		justify-content: center;
		left: 60px;
		cursor: pointer;
	}

	// 响应式

	@media screen and (min-width: 1200px) {}

	@media screen and (min-width: 923px) and (max-width:1199px) {}

	@media screen and (min-width: 768px) and (max-width:922px) {}

	@media screen and (max-width: 922px) {
		.container {
			width: 100%;
			position: absolute;
			left: 0;
			margin-left: 0;
			background: url(../../assets/home/top_bg.png);
			background-size: auto 120%;
			margin-top: -120px;
			padding-top: 120px;
			display: block;

			.container-bg {
				position: absolute;
				left: 0;
				right: 0;
				top: 0px;
				width: 100%;
			}

			.mobile {
				display: block;
			}

			.con-group {
				display: flex;
				flex-wrap: wrap;
				padding: 0px;
				justify-content: center;
				width: 100%;

				.con-item {
					width: 90vw;
					height: 55vw;
					padding: 10px 20px 10px 10px;
					margin-bottom: 20px;

					img {
						flex-shrink: 0;
						width: 80px;
						height: 80px;
					}

					.title {
						font-size: 26px;
						font-weight: bold;
					}

					.text {
						font-size: 14px;
						padding-top: 3px;
					}
				}
			}
		}
	}
</style>